export class LoginRequestDTO {    
    Usuario!:string;
    Clave!:string;    
}  